import { agencyApis } from '@apis/dashboard/agencyApis';
import { createUseQuery } from '@hooks/createUseQuery';
import { FcAgencyGetQuery } from '@models/Agency';

export const useFcAgency = createUseQuery(
  (query: FcAgencyGetQuery) => ['/fc/agency/', query],
  (query) => async () => {
    const response = await agencyApis.get('/fc/agency/', {
      query,
    });
    if (response[400]) {
      throw response[400];
    }

    return response[200]!;
  },
);
